import {atom} from "jotai";


export const atomCartWidget = atom(false);
